import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class InstrumentSearchItem {
  symbol: string | null = null
  description: string | null = null
  exchange: string | null = null
  instrumentType: string | null = null
  category: string | null = null
  eventProductExternalId: string | null = null
  externalId: string | null = null
  hasOptions: boolean | null = null
  instrumentSubType?: string | null = null
}

export const INSTRUMENT_SEARCH_ITEM_DESER: SchemaDeSer<InstrumentSearchItem> =
  new SchemaDeSerBuilder(InstrumentSearchItem)
    .ofNullableString("symbol")
    .ofNullableString("description")
    .ofNullableString("exchange")
    .ofNullableString("instrumentType")
    .ofNullableString("category")
    .ofNullableString("eventProductExternalId")
    .ofNullableString("externalId")
    .ofBooleans("hasOptions")
    .ofNullableString("instrumentSubType")
    .toDeSer()

export class SymbolSearchItem {
  symbol: string | null = null
  description: string | null = null
  listedMarket: string | null = null
  instrumentType: string | null = null
  category: string | null = null
  eventProductExternalId: string | null = null
  externalId: string | null = null
  options = false
  etf = false
}

export const SYMBOL_SEARCH_ITEM_DESER: SchemaDeSer<SymbolSearchItem> =
  new SchemaDeSerBuilder(SymbolSearchItem)
    .ofNullableString("symbol")
    .ofNullableString("description")
    .ofNullableString("listedMarket")
    .ofNullableString("instrumentType")
    .ofNullableString("category")
    .ofNullableString("eventProductExternalId")
    .ofNullableString("externalId")
    .ofBooleans("options", "etf")
    .toDeSer()
